// src/components/issues/EtiquettesSoeurs.tsx — SCE Issues
// Un défaut sur plusieurs équipements, sur UNE rangée de liste (26/10, option A
// de https://claude.ai/artifact/JPGMp9Yx21HzKSok5x2YAL) : sous le titre,
// « 3 équipements » puis une étiquette par fiche sœur — N° de série, état, badge
// de CET équipement. Une étiquette ouvre SA fiche ; le reste de la rangée ouvre
// celle de la rangée. Tableau du bureau et rangées du téléphone.

import { Layers } from 'lucide-react'
import { IconeStatut, LIBELLE_STATUT_LISTE } from '@/components/ui/EtatProbleme'
import type { Issue } from '@/types/issue.types'
import { libelleMachines } from '@/utils/groupes'
import { BadgesCompacts } from './tableau/valeurs'

export function EtiquettesSoeurs({
  soeurs,
  onOuvrir,
}: {
  soeurs: readonly Issue[]
  onOuvrir: (issue: Issue) => void
}): JSX.Element {
  return (
    <span className="etiquettes-soeurs">
      <span className="etiquettes-soeurs-nb">
        <Layers size={14} aria-hidden="true" />
        {libelleMachines(soeurs.length)}
      </span>
      {soeurs.map((s) => (
        <button
          key={s.id}
          type="button"
          className="etiquette-soeur"
          title={`Ouvrir ${s.id} · ${LIBELLE_STATUT_LISTE[s.statut]}`}
          onClick={(e) => {
            // La rangée est cliquable elle aussi : l'étiquette passe avant.
            e.stopPropagation()
            onOuvrir(s)
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <b>{s.numeroSerie || 'Sans équipement'}</b>
          <IconeStatut statut={s.statut} />
          <span className="sr-only">{LIBELLE_STATUT_LISTE[s.statut]}</span>
          <BadgesCompacts issue={s} />
        </button>
      ))}
    </span>
  )
}
